export interface Article {
  id: number;
  title: string;
  summary: string;
  content: string;
  date: string;
  category: string;
  image: string;
  author: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026年暑期档最值得期待的十部电影',
    summary: '暑期档大片云集，从科幻巨制到温情文艺片，我们为你精选了今夏不容错过的十部佳作。',
    content: `<p>随着2026年暑期档的火热开启，各大影院迎来了观影热潮。今年的暑期档可谓百花齐放，从国产科幻巨制到温情文艺片，从爆笑喜剧到悬疑惊悚，各种类型应有尽有。</p>
    <h3>科幻巨制领跑暑期档</h3>
    <p>《星际迷航：新纪元》作为今年暑期档的开门红，以震撼的视觉特效和深刻的哲学思考征服了观众。影片讲述了人类在星际探索中发现全新文明的壮丽故事，特效团队耗时两年打造了令人叹为观止的星际场景。</p>
    <p>《流浪地球3》延续了前作的宏大叙事，这一次人类面临更加严峻的太阳危机。导演郭帆表示，第三部在情感表达上更加丰富，不仅有震撼的太空场景，更有人物命运的深刻刻画。</p>
    <h3>国产动画持续发力</h3>
    <p>《哪吒之魔童闹海》作为《哪吒之魔童降世》的续作，承载着观众的厚望。影片在视觉效果上再次突破，将中国传统水墨画风与现代CG技术完美融合。据制片方透露，影片的特效镜头数量比前作增加了近一倍。</p>
    <p>《深海》则是另一部备受关注的国产动画，影片以独特的粒子水墨风格创造了令人惊艳的视觉体验。导演田晓鹏表示，这是一部关于成长、勇气与自我救赎的作品。</p>
    <h3>温情文艺片不容错过</h3>
    <p>《逆光而行》是一部关于盲人摄影师的励志故事，影片以细腻的情感刻画和唯美的画面语言打动了无数观众。豆瓣评分高达8.5分，被誉为"今年最温暖的电影"。</p>`,
    date: '2026-08-08',
    category: '电影资讯',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20interior%20with%20movie%20posters%20on%20wall%2C%20warm%20theater%20lighting%2C%20film%20reels%20and%20popcorn%2C%20artistic%20cinema%20photography%2C%20cozy%20atmosphere%2C%20rich%20coral%20and%20gold%20tones&width=1200&height=600&seq=hongtao-article-detail-01&orientation=landscape',
    author: '红桃影视编辑部',
  },
  {
    id: 2,
    title: '国产动漫崛起：从《哪吒》到《深海》的蜕变之路',
    summary: '中国动画电影正在经历一场前所未有的复兴，技术突破与故事创新齐头并进。',
    content: `<p>近年来，中国动画电影市场呈现出前所未有的繁荣景象。从2019年《哪吒之魔童降世》创造50亿票房神话，到《深海》以独特的视觉风格惊艳世界，国产动画正在经历一场深刻的蜕变。</p>
    <h3>技术突破：从模仿到创新</h3>
    <p>早期的国产动画在技术上与国际一流水平存在明显差距。然而，随着国内动画人才的培养和技术积累，这一差距正在迅速缩小。《深海》团队自主研发的"粒子水墨"技术，将中国传统水墨画的韵味与现代CG技术完美结合，创造了独一无二的视觉语言。</p>
    <p>《哪吒之魔童闹海》在特效制作上更是达到了新的高度。据悉，影片的制作团队超过2000人，特效镜头数量突破2000个，其中多个场景达到了国际顶尖水准。</p>
    <h3>故事创新：扎根中国文化</h3>
    <p>国产动画的另一大优势在于对中国传统文化的深度挖掘。《哪吒》系列取材于中国传统神话，《深海》则从《西游记》中汲取灵感。这些作品不是简单地复制传统故事，而是在尊重文化底蕴的基础上进行创新性改编。</p>`,
    date: '2026-08-06',
    category: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20creative%20workspace%2C%20colorful%20character%20designs%20on%20screen%2C%20warm%20studio%20lighting&width=1200&height=600&seq=hongtao-article-detail-02&orientation=landscape',
    author: '红桃影视编辑部',
  },
  {
    id: 3,
    title: '高分纪录片推荐：打开世界的另一种方式',
    summary: '十部改变认知的纪录片，带你领略自然奇观、人文历史与科技前沿的无限魅力。',
    content: `<p>纪录片是打开世界的一扇窗户。在这个信息爆炸的时代，一部优秀的纪录片能够帮助我们静下心来，重新认识这个世界。今天，红桃影视为你推荐十部不可错过的高分纪录片。</p>
    <h3>自然奇观篇</h3>
    <p>《地球脉动：海洋深处》是BBC自然历史部的最新力作。摄制组耗时四年，深入全球各大洋，用最先进的深海拍摄技术捕捉到了前所未有的画面。从发光的深海生物到壮观的鲸群迁徙，每一帧都是视觉盛宴。</p>
    <p>《航拍中国第五季》则用航拍视角展现了中国的壮美山河。从青藏高原的雪山到海南的热带雨林，从东北的广袤森林到西南的喀斯特地貌，中国大地的多样性令人叹为观止。</p>
    <h3>人文历史篇</h3>
    <p>《大国工匠》记录了中国各行各业的顶尖工匠，从陶瓷大师到刺绣传人，从木雕匠人到铁画艺术家。他们的故事不仅是个人的传奇，更是中华文化传承的缩影。</p>`,
    date: '2026-08-04',
    category: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20screening%20room%2C%20large%20projection%20screen%20showing%20nature%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20cinematic%20atmosphere&width=1200&height=600&seq=hongtao-article-detail-03&orientation=landscape',
    author: '红桃影视编辑部',
  },
  {
    id: 4,
    title: '电视剧《长安十二时辰》背后的历史密码',
    summary: '深度解析热播剧中的大唐风貌，还原真实的历史场景与文化细节。',
    content: `<p>《长安十二时辰》以唐天宝三年为背景，讲述了死囚张小敬在十二时辰内拯救长安城的故事。剧中对唐代社会风貌的还原程度令人惊叹，每一个细节都经过了严谨的历史考据。</p>
    <h3>长安城的真实面貌</h3>
    <p>唐代长安城是当时世界上最大的城市，面积达84平方公里，人口超过百万。剧中展现的坊市制度、宵禁制度都真实反映了唐代的城市管理方式。长安城分为108个坊，每个坊都有自己的坊门和坊正，夜间坊门关闭后禁止外出。</p>
    <h3>服饰与礼仪</h3>
    <p>剧中的服饰设计参考了大量唐代壁画和出土文物。从官员的朝服到平民的日常装束，从女子的高髻到男子的幞头，都力求还原历史原貌。特别值得一提的是剧中展现的叉手礼，这是唐代最普遍的问候方式。</p>`,
    date: '2026-08-02',
    category: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%2C%20Tang%20Dynasty%20palace%20interior%2C%20ancient%20Chinese%20architecture%2C%20warm%20lantern%20light%2C%20traditional%20costumes%2C%20cinematic%20lighting&width=1200&height=600&seq=hongtao-article-detail-04&orientation=landscape',
    author: '红桃影视编辑部',
  },
  {
    id: 5,
    title: '综艺节目的创新之路：从娱乐到文化的跨越',
    summary: '当代综艺节目正在经历从纯娱乐向文化内涵的转型，探讨综艺节目的社会价值。',
    content: `<p>曾几何时，综艺节目被视为"快餐文化"的代表。但近年来，一批具有文化内涵的综艺节目改变了这一印象，它们不仅提供娱乐，更传递着知识与价值观。</p>
    <h3>文化类综艺的崛起</h3>
    <p>《美食探秘：寻味中国》将美食与文化探索相结合，每一集不仅展示地方美食的制作过程，更深入探讨美食背后的历史渊源和人文故事。节目播出后，多个取景地的旅游搜索量增长了300%以上。</p>
    <p>《声入人心》系列则打破了大众对美声唱法的刻板印象，将古典音乐以通俗易懂的方式呈现给观众。节目不仅培养了一批年轻的古典音乐爱好者，更推动了国内音乐剧市场的发展。</p>`,
    date: '2026-07-30',
    category: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20production%20studio%2C%20stage%20with%20colorful%20lighting%2C%20audience%20seats%2C%20professional%20broadcast%20equipment%2C%20warm%20studio%20atmosphere&width=1200&height=600&seq=hongtao-article-detail-05&orientation=landscape',
    author: '红桃影视编辑部',
  },
  {
    id: 6,
    title: '科幻电影为什么越来越"硬核"了？',
    summary: '从软科幻到硬科幻的转变，探讨当代科幻电影的科学准确性与艺术表达的平衡。',
    content: `<p>近年来，科幻电影呈现出一个明显的趋势：越来越"硬核"。从《星际穿越》中对黑洞的科学模拟，到《流浪地球》中对行星发动机的工程设想，科幻电影正在向科学靠拢。</p>
    <h3>科学顾问的崛起</h3>
    <p>如今，几乎每一部科幻大片都会聘请专业的科学顾问团队。《星际迷航：新纪元》邀请了多位天体物理学家参与剧本创作，确保影片中的科学设定经得起推敲。这种趋势反映了观众科学素养的提高——他们不再满足于天马行空的想象，而是希望在科幻作品中看到真实的科学。</p>`,
    date: '2026-07-28',
    category: '电影资讯',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20making%20behind%20scenes%2C%20film%20crew%20with%20green%20screen%20and%20cameras%2C%20futuristic%20set%20design%2C%20professional%20film%20production%2C%20warm%20studio%20lighting&width=1200&height=600&seq=hongtao-article-detail-06&orientation=landscape',
    author: '红桃影视编辑部',
  },
];

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(currentId: number, limit: number = 3): Article[] {
  return articles.filter((a) => a.id !== currentId).slice(0, limit);
}